import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-8 border border-gray-100"
      >
        <h1 className="text-3xl font-bold text-gray-900 mb-6 border-b pb-4 text-center">Política de Privacidade</h1>
        
        <div className="space-y-6 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">1. Coleta de Informações</h2>
            <p>Coletamos informações necessárias para a prestação de nossos serviços, incluindo dados de identificação como CPF, nome e e-mail, além de informações técnicas de navegação.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">2. Uso das Informações</h2>
            <p>Seus dados são utilizados exclusivamente para realizar as consultas solicitadas, processar pagamentos de negociação e enviar comunicações importantes sobre seus pedidos de suporte ou status de dívidas.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">3. Proteção de Dados</h2>
            <p>Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração ou destruição. Seus dados sensíveis são criptografados durante o trânsito.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">4. Compartilhamento com Terceiros</h2>
            <p>Não vendemos seus dados para terceiros. Compartilhamos informações apenas com parceiros essenciais para o funcionamento do serviço, como bureaus de crédito e gateways de pagamento seguros.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">5. Seus Direitos</h2>
            <p>De acordo com a LGPD, você tem o direito de acessar, corrigir ou solicitar a exclusão de seus dados pessoais a qualquer momento através de nosso canal de suporte.</p>
          </section>

          <p className="text-sm text-gray-400 mt-8 text-center italic">Última atualização: 10 de Abril de 2026</p>
        </div>
      </motion.div>
    </div>
  );
};

export default Privacy;
